import { city } from "ca-plateform-project-domain";
import { http } from "../../http";
import { buildProjectApiUrl } from "../../configuration";

export interface ArchivedCampaignEvent
  extends city.colisactiv.project.model.features.ArchivedCampaignEvent {}

export const archiveCampaignCommand = (
  projectId: string,
  campaignId: string
): Promise<ArchivedCampaignEvent> =>
  http.put<ArchivedCampaignEvent>(
    buildProjectApiUrl(
      `/projects/${projectId}/campaigns/${campaignId}/status/archive`
    )
  );
